// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ld-0";